import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TraineesResponse, ManagersResponse, CoachesResponse, CreateCoachRequest, CreateManagerRequest, UpdateManagerRequest, PaginatedUsersResponse, UpdatePasswordRequest, UserProfile, UpdateProfileRequest, SubUser } from '../models/user.model';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../models/common.model';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private apiUrl = `${environment.apiUrl}/user`;

  constructor(private http: HttpClient) {}

  getTrainees(): Observable<TraineesResponse> {
    return this.http.get<TraineesResponse>(`${this.apiUrl}/trainees`);
  }

  getManagers(): Observable<ManagersResponse> {
    return this.http.get<ManagersResponse>(`${this.apiUrl}/managers`);
  }

  getCoaches(): Observable<CoachesResponse> {
    return this.http.get<CoachesResponse>(`${this.apiUrl}/coaches`);
  }

  createCoach(request: CreateCoachRequest): Observable<ApiResponse<any>> {
    return this.http.post<ApiResponse<any>>(`${this.apiUrl}/coaches`, request);
  }

  createManager(request: CreateManagerRequest): Observable<ApiResponse<any>> {
    return this.http.post<ApiResponse<any>>(`${this.apiUrl}/managers`, request);
  }

  updateManager(id: string, request: UpdateManagerRequest): Observable<ApiResponse<any>> {
    return this.http.put<ApiResponse<any>>(`${this.apiUrl}/managers/${id}`, request);
  }

  getAllUsers(search?: string, role?: string, page: number = 1, pageSize: number = 25): Observable<PaginatedUsersResponse> {
    let params = new HttpParams();
    if (search) {
      params = params.set('search', search);
    }
    if (role) {
      params = params.set('role', role);
    }
    params = params.set('page', page.toString());
    params = params.set('pageSize', pageSize.toString());
    return this.http.get<PaginatedUsersResponse>(`${this.apiUrl}/all`, { params });
  }

  updateUserPassword(request: UpdatePasswordRequest): Observable<ApiResponse<null>> {
    return this.http.put<ApiResponse<null>>(`${this.apiUrl}/update-password`, request);
  }

  getUserProfile(userId: string): Observable<ApiResponse<UserProfile>> {
    return this.http.get<ApiResponse<UserProfile>>(`${environment.apiUrl}/profile/${userId}`);
  }

  updateUserProfile(userId: string, data: UpdateProfileRequest): Observable<ApiResponse<null>> {
    return this.http.put<ApiResponse<null>>(`${environment.apiUrl}/profile/${userId}`, data);
  }

  getSubUsers(userId: string): Observable<ApiResponse<SubUser[]>> {
    return this.http.get<ApiResponse<SubUser[]>>(`${environment.apiUrl}/sub-users/by-user/${userId}`);
  }

  verifyUserPhone(userId: string): Observable<ApiResponse<null>> {
    return this.http.put<ApiResponse<null>>(`${this.apiUrl}/verify-phone`, { userId });
  }

  getManagerPermissions(managerId: string): Observable<ApiResponse<any>> {
    return this.http.get<ApiResponse<any>>(`${this.apiUrl}/managers/${managerId}/permissions`);
  }

  setManagerPermissions(managerId: string, request: any): Observable<ApiResponse<any>> {
    return this.http.put<ApiResponse<any>>(`${this.apiUrl}/managers/${managerId}/permissions`, request);
  }

  getMe(): Observable<ApiResponse<any>> {
    return this.http.get<ApiResponse<any>>(`${environment.apiUrl}/auth/me`);
  }
}
